var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 155,
    viewBox: "0 0 148 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3172_29438)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.0055,
    cy: 145.613,
    rx: 59.6774,
    ry: 2.3871,
    fill: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40214 74.4978C5.95132 72.2014 7.57032 70.0138 9.89824 69.7739L56.6877 64.9516C67.4683 63.8405 78.1251 61.7484 88.5256 58.7014L133.666 45.477C135.911 44.819 138.237 46.2322 138.688 48.5286L141.756 64.1558C142.207 66.4522 140.588 68.6398 138.26 68.8797L91.4704 73.702C80.6898 74.8131 70.033 76.9052 59.6325 79.9522L14.4924 93.1766C12.2466 93.8346 9.92074 92.4214 9.46993 90.125L6.40214 74.4978Z",
    fill: "#DBDBDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9141 87.0147L72.2637 98.1421L56.8319 126.364C55.8859 128.094 53.3694 127.996 52.5605 126.198L49.6696 119.771C49.2549 118.849 48.3048 118.289 47.2975 118.371L38.5943 119.085C36.7004 119.24 35.3931 117.228 36.3048 115.561L51.9141 87.0147Z",
    fill: "#E9E9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2109 87.0147L71.8613 98.1421L87.2931 126.364C88.2391 128.094 90.7556 127.996 91.5645 126.198L94.4554 119.771C94.8701 118.849 95.8202 118.289 96.8275 118.371L105.531 119.085C107.425 119.24 108.732 117.228 107.82 115.561L92.2109 87.0147Z",
    fill: "#E9E9E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6325 29.3565C70.1803 26.2047 74.9856 26.2047 77.5334 29.3565L79.89 32.2719C81.473 34.2302 84.0616 35.0713 86.4933 34.4175L90.1135 33.4441C94.0273 32.3918 97.9149 35.2163 98.1235 39.2637L98.3165 43.0075C98.4461 45.5222 100.046 47.7242 102.398 48.6246L105.898 49.965C109.683 51.4141 111.168 55.9842 108.958 59.3813L106.914 62.5235C105.54 64.6342 105.54 67.356 106.914 69.4666L108.958 72.6089C111.168 76.0059 109.683 80.576 105.898 82.0252L102.398 83.3656C100.046 84.266 98.4461 86.4679 98.3165 88.9827L98.1235 92.7265C97.9149 96.7739 94.0273 99.5984 90.1135 98.5461L86.4933 97.5727C84.0616 96.9189 81.473 97.76 79.89 99.7182L77.5334 102.634C74.9856 105.785 70.1803 105.785 67.6325 102.634L65.2758 99.7182C63.6928 97.76 61.1042 96.9189 58.6725 97.5727L55.0523 98.5461C51.1385 99.5984 47.251 96.7739 47.0423 92.7265L46.8494 88.9827C46.7197 86.4679 45.1199 84.266 42.7683 83.3656L39.2674 82.0252C35.4825 80.576 33.9976 76.0059 36.2078 72.6089L38.2523 69.4666C39.6255 67.356 39.6255 64.6342 38.2523 62.5235L36.2078 59.3813C33.9976 55.9842 35.4825 51.4141 39.2674 49.965L42.7683 48.6246C45.1199 47.7242 46.7197 45.5222 46.8494 43.0075L47.0423 39.2637C47.251 35.2163 51.1385 32.3918 55.0523 33.4441L58.6725 34.4175C61.1042 35.0713 63.6928 34.2302 65.2758 32.2719L67.6325 29.3565Z",
    fill: "url(#paint0_linear_3172_29438)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5538 74.2647C69.503 75.305 67.8105 75.305 66.7596 74.2647L60.2222 67.7926C59.4502 67.0284 59.4502 65.7811 60.2222 65.0169C60.9824 64.2643 62.2068 64.2634 62.9681 65.015L68.6567 70.6311L82.2057 57.2176C82.9708 56.4601 84.2039 56.4623 84.9664 57.2225C85.7359 57.9897 85.7337 59.2367 84.9614 60.0012L70.5538 74.2647Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9354 16.71L28.2987 22.0815L33.8286 21.7181L29.1412 24.6746L31.1956 29.8215L26.9354 26.2772L22.6752 29.8215L24.7296 24.6746L20.0422 21.7181L25.5721 22.0815L26.9354 16.71Z",
    fill: "#F0BE60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.599 31.2061L123.583 34.5708L126.947 35.5548L123.583 36.5388L122.599 39.9035L121.615 36.5388L118.25 35.5548L121.615 34.5708L122.599 31.2061Z",
    fill: "#9B1E26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6847 106.584L20.6687 109.949L24.0334 110.933L20.6687 111.917L19.6847 115.281L18.7007 111.917L15.3359 110.933L18.7007 109.949L19.6847 106.584Z",
    fill: "#DFF3A4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3172_29438",
    x: 7.96253,
    y: 136.86,
    width: 132.087,
    height: 17.5054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1828,
    result: "effect1_foregroundBlur_3172_29438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3172_29438",
    x1: 111.956,
    y1: 32.9584,
    x2: 111.956,
    y2: 105.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#287A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.a892457130e8ac5885d9b22585a7b24e.svg";
export { ForwardRef as ReactComponent };